import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  radioSwitchViewContainer: {
    overflow: 'hidden',
    width: 'auto',
    display: 'inline',
  },
  radioSwitchView: {
    marginLeft: '0.5rem',
  },
  avoidUserSelect: {
    userSelect: 'none',
  },
})

export default useStyles
